import React from 'react';
import { Button } from '@chakra-ui/core';
import { IoMdRefresh } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from '../../models/hooks';
import { StatusOptions } from './types';

export const RefetchTodo = React.memo(function RefetchTodo() {
  const { t } = useTranslation('toDoList');
  const { refetchTodos } = useStoreActions((actions) => actions.todo);
  const { isRefetching, isLoading, statusFilters } = useStoreState((state) => state.todo);
  const accountId = useStoreState((state) => state.app.accounts?.id);

  React.useEffect(() => {
    if (accountId && statusFilters.includes(StatusOptions.COMPLETED)) {
      refetchTodos({ accountId, needCompleted: true }).catch((error) => {
        console.error('Failed to refresh todos:', error);
      });
    }
  }, [accountId, refetchTodos, statusFilters]);

  if (isLoading) return null;

  const onRefreshTodo = () => {
    if (accountId) {
      refetchTodos({ accountId, needCompleted: false }).catch((error) => {
        console.error('Failed to refresh todos:', error);
      });
    }
  };

  return (
    <Button
      onClick={onRefreshTodo}
      size="md"
      fontSize="sm"
      colorScheme="gray"
      leftIcon={<IoMdRefresh size={20} />}
      data-testid="refreshBtn"
      mr={4}
      variant="outline"
      disabled={isRefetching || isLoading}
      isLoading={isRefetching || isLoading}
    >
      {t('jobPosition:refresh')}
    </Button>
  );
});
